import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";
import {
  getFPKerfImage,
  getSliderKerfImage,
  getSwingKerfImage,
  getBifoldKerfImage,
  getPivotKerfImage,
} from "./kerfImages";

interface UpdateObj {
  kerfConfig?: string;
  kerf?: string;
  jamb?: string;
  kerfSetback?: string;
}

const useKerfSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const material = useStore((state) => state.quote.material);
  const swingDirection = useStore((state) => state.quote.swingDirection);
  const screenType = useStore((state) => state.quote.screenType);
  const addScreen = useStore((state) => state.quote.addScreen);

  const kerf = useStore((state) => state.quote.kerf);
  const kerfConfig = useStore((state) => state.quote.kerfConfig);
  const kerfSetback = useStore((state) => state.quote.kerfSetback);

  const jamb = useStore((state) => state.quote.jamb);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (!value) {
      addToQuote({ kerfSetback: "" });
    } else {
      addToQuote({ kerfSetback: value });
      if (findRequired("Kerf Custom Setback"))
        removeRequired("Kerf Custom Setback");
    }
  };

  const showSetbackInput =
    kerf && kerfConfig === "Custom Setback" ? true : false;

  const handleClickKerf = (label: string) => {
    const checked = label === kerf;

    if (checked) {
      let update: UpdateObj = {
        kerfConfig: "",
        kerf: "",
      };

      if (jamb) {
        update["jamb"] = "";
      }

      addToQuote(update);
    } else {
      if (findRequired("Kerf Custom Setback")) {
        removeRequired("Kerf Setback");
        removeRequired("Kerf Custom Setback");
      }

      let update: UpdateObj = {
        kerf: label,
        kerfConfig: 'Standard 3/8" Setback',
      };

      if (kerfSetback) update["kerfSetback"] = "";

      if (jamb) {
        update["jamb"] = "";
      }

      addToQuote(update);
    }
  };

  const handleClickOptions = (label: string) => {
    const checked = label === kerfConfig;

    let update: UpdateObj = { kerfSetback: "" };

    if (checked) {
      update["kerfConfig"] = "";
    } else {
      if (findRequired("Kerf Custom Setback")) {
        removeRequired("Kerf Setback");
      }
      update["kerfConfig"] = label;
    }

    addToQuote(update);
  };

  const kerfSetbackDoor = !showSetbackInput
    ? ""
    : doorType === "Swing" && swingDirection
    ? swingDirection
    : doorType === "Fixed Panel"
    ? exactConfig
    : doorType;

  const kerfSetbackMaterial = !showSetbackInput
    ? ""
    : doorType === "Pivot"
    ? material
    : doorType === "Swing"
    ? material
    : doorType === "Fixed Panel"
    ? material
    : "";

  const publicId = !kerf
    ? ""
    : doorType === "Fixed Panel"
    ? getFPKerfImage(material, exactConfig)
    : doorType.includes("Bi-fold")
    ? getBifoldKerfImage(addScreen || "", screenType || "", material)
    : doorType === "Slider"
    ? getSliderKerfImage(addScreen || "", screenType || "", material)
    : doorType === "Pivot"
    ? getPivotKerfImage(material)
    : getSwingKerfImage(
        swingDirection || "",
        addScreen || "",
        screenType || "",
        material
      );

  return {
    handleClickOptions,
    handleClickKerf,
    showSetbackInput,
    handleChange,
    kerfSetbackDoor,
    kerfSetbackMaterial,
    publicId,
    kerf,
    kerfConfig,
    kerfSetback
  };
};

export default useKerfSelector;
